import styled from 'styled-components'
import { TypeBeetle, TypeSmart } from '@at/design-system-foundation'

export const InterceptContainer = styled.div`
    min-height: 100px;
    text-align: center;
    color: ${({ theme }) => theme.color.text.default};
    grid-column: 1 / -1;
    width: 100%;
    padding: 16px;
    margin-bottom: 16px;
    border-radius: 16px;
`

export const InterceptTitle = styled(TypeBeetle)`
    font-size: 18px;
    font-variation-settings: 'wght' 400;
    line-height: 24px;
`
export const InterceptSubTitle = styled(TypeSmart)`
    font-size: 14px;
    font-variation-settings: 'wght' 400;
    line-height: 20px;
    margin: 10px 0;
`
